import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, Eyebrow } from "./motion";
import { PlanGate } from "./PlanGate";

const INCL = ["Direito de entrada", "Formação", "Tecnologia", "Obras, adaptação e mobiliário", "Apoio à abertura", "Acompanhamento inicial"];

export const Investment = () => {
  const [gate, setGate] = useState(false);
  return (
    <section id="investimento" className="bg-white py-24 text-ink sm:py-36">
    <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
      <div className="relative overflow-hidden rounded-[36px] bg-navy p-7 text-white sm:p-14 lg:p-20" data-testid="investment-card">
        <div className="spot pointer-events-none absolute -right-40 -top-40 h-[600px] w-[600px]" />
        <div className="relative grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Eyebrow dark num="09">Investimento indicativo</Eyebrow>
            <p className="mt-8 font-mono text-sm uppercase tracking-[0.2em] text-slate-300">Entre</p>
            <h2 className="font-display text-4xl font-black leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl" data-testid="investment-range">
              <MaskLines lines={["25.000€", <span className="text-orange">35.000€</span>]} />
            </h2>
            <button onClick={() => setGate(true)} data-testid="investment-cta" className="group mt-10 inline-flex items-center gap-3 rounded-full bg-white px-7 py-4 font-bold text-navy ring-1 ring-ink/10 transition-[background-color,color,transform] duration-300 hover:-translate-y-1 hover:bg-orange hover:text-white">
              Conheça o plano financeiro <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:rotate-45" />
            </button>
          </div>
          <div className="lg:col-span-5">
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-slate-300">Incluindo</p>
            <ul className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
              {INCL.map((t, i) => (
                <Reveal as="li" key={t} delay={i * 0.06} className="flex items-center justify-between rounded-2xl border border-white/10 bg-white/[0.03] px-5 py-4 transition-[border-color,background-color] duration-300 hover:border-orange/60 hover:bg-white/[0.06]">
                  <span className="font-display font-bold">{t}</span>
                  <span className="font-mono text-xs text-orange">0{i + 1}</span>
                </Reveal>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <PlanGate open={gate} onClose={() => setGate(false)} items={INCL} />
    </div>
  </section>
  );
};
